import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Numa aplicação de página única o browser não reinicia o scroll ao mudar de
 * rota: entrava-se numa página nova já a meio dela. Este componente repõe o
 * topo sempre que o caminho muda.
 *
 * Exceções:
 * - navegação para trás/frente (POP), onde se devolve ao visitante a posição
 *   onde estava;
 * - links com âncora (#orcamento), que têm destino próprio dentro da página.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;
    if (hash) return;

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname, hash, navigationType]);

  return null;
};

export default ScrollToTop;
